const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/layout/ProtectedRoute.tsx';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { isSecuredLocationPath } from 'App/utils/urlLocationCheck';
import { isLoggedIn } from 'App/store/login';

/**
 * Same as Route, but we ensure the user has successfully logged in, otherwise we redirect to /.
 */
export const ProtectedRoute = ({ children, ...otherProps }: RouteProps) => {
    const canSeeRoutes = useSelector(isLoggedIn) || isSecuredLocationPath();

    return canSeeRoutes ? <Route {...otherProps}>{children}</Route> : <Redirect to="/" />;
};
